import { useCallback, useMemo, useState } from "react"
import type { ClaimedByReportFilters } from "../lib/claimed-by-workscope-status"

const EMPTY_FILTERS: ClaimedByReportFilters = {
  workscopes: [],
  dateCompletedFrom: "",
  dateCompletedTo: "",
}

export function useClaimedByReportFilters() {
  const [filters, setFilters] = useState<ClaimedByReportFilters>(EMPTY_FILTERS)

  const clearFilters = useCallback(() => {
    setFilters(EMPTY_FILTERS)
  }, [])

  const hasActiveFilters = useMemo(
    () => filters.workscopes.length > 0
      || Boolean(filters.dateCompletedFrom)
      || Boolean(filters.dateCompletedTo),
    [filters],
  )

  return {
    filters,
    setFilters,
    clearFilters,
    hasActiveFilters,
  }
}
